import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route for the /blog segment. Renders nothing of its own — it exists
// so the /blog index, /blog/$slug detail, and /blog/rss.xml routes share a
// parent. Per-page SEO lives in those child routes.
export const Route = createFileRoute("/blog")({
  component: Outlet,
});
